// extracted by mini-css-extract-plugin
export var active = "PageNav-module--active--dTL0A";
export var nav = "PageNav-module--nav--H2Ovz";
export var navItem = "PageNav-module--navItem--5+hTT";